import { apiClient } from './client'

export type AdminApiKey = {
  id: string
  name: string
  keyPrefix: string
  createdAt: string
  createdByUserId?: string | null
  lastUsedAt?: string | null
  expiresAt?: string | null
  revokedAt?: string | null
  isActive: boolean
}

export type CreatedAdminApiKey = AdminApiKey & {
  key: string
}

export type CreateAdminApiKeyRequest = {
  name: string
  expiresAt?: string | null
}

export async function listAdminApiKeys(): Promise<AdminApiKey[]> {
  const { data } = await apiClient.get<AdminApiKey[]>('/api/admin/api-keys')
  return data
}

export async function createAdminApiKey(
  payload: CreateAdminApiKeyRequest
): Promise<CreatedAdminApiKey> {
  const { data } = await apiClient.post<CreatedAdminApiKey>('/api/admin/api-keys', payload)
  return data
}

export async function revokeAdminApiKey(id: string): Promise<void> {
  await apiClient.delete(`/api/admin/api-keys/${encodeURIComponent(id)}`)
}
